import { Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";
import type { ActivityFeedDayGroup } from "./groupByDay";

export type DayGroupProps = {
  group: ActivityFeedDayGroup;
};

export const DayGroup = ({ group }: DayGroupProps) => {
  return (
    <Flex className={styles.dayGroup} flexDirection="column">
      <Text variant="secondary-sm" className={styles.dayLabel}>
        {group.dayLabel}
      </Text>
      {group.entries.map((entry) => (
        <Flex key={entry.id} className={styles.entryRow} flexDirection="column">
          <Text variant="regular-sm" color={Colors.Neutral900}>
            {entry.message}
          </Text>
          <Flex gap={SPACING.X_SMALL} alignItems="center">
            <Text variant="secondary-sm" color={Colors.Neutral600}>
              {entry.actorName}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
